import Icon, { IconProps } from './Icon';

import ToolIcon from '../../../assets/icons/tool-01.svg?react';

const Tool: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <ToolIcon />
        </Icon>
    );
};

export default Tool;
